module.exports = __webpack_public_path__ + "src/components/icon-shopping-optician-category.bc7946c4e9c41d23fb23dfe9b1f10ccf.svg";